import type { EntitySeo, SeoContext, SeoResolver } from './types';
import { pdsSeoResolver } from './resolvers/pdsSeo';
import { policeSeoResolver } from './resolvers/policeSeo';
import { healthSeoResolver } from './resolvers/healthSeo';
import { registrationSeoResolver } from './resolvers/registrationSeo';
import { localBodySeoResolver } from './resolvers/localBodySeo';
import { veterinarySeoResolver } from './resolvers/veterinarySeo';
import { landParcelSeoResolver } from './resolvers/landParcelSeo';
import { tnebSeoResolver } from './resolvers/tnebSeo';
import { templeSeoResolver } from './resolvers/templeSeo';
import { constituencySeoResolver } from './resolvers/constituencySeo';
import { radioSeoResolver } from './resolvers/radioSeo';
import { fuelSeoResolver } from './resolvers/fuelSeo';

/**
 * Priority-ordered list of module resolvers. The first whose entity is active
 * wins. Only migrated modules live here; every other layer still branches
 * inline in SEO.tsx until it is migrated onto the framework.
 *
 * Selections are mutually exclusive per active layer (switching layers clears
 * the others), so ordering here only matters between modules that can be active
 * simultaneously — none can today.
 */
// Order mirrors the entity-branch order in SEO.tsx so that, in the (currently
// impossible) case of two selections being active at once, the same module wins
// here as would win there.
const RESOLVERS: SeoResolver[] = [
  pdsSeoResolver,
  policeSeoResolver,
  healthSeoResolver,
  registrationSeoResolver,
  localBodySeoResolver,
  veterinarySeoResolver,
  landParcelSeoResolver,
  tnebSeoResolver,
  templeSeoResolver,
  constituencySeoResolver,
  radioSeoResolver,
  fuelSeoResolver
];

export function resolveEntitySeo(ctx: SeoContext): EntitySeo | null {
  for (const resolve of RESOLVERS) {
    const result = resolve(ctx);
    if (result) return result;
  }
  return null;
}

export type { EntitySeo, SeoContext, SeoResolver } from './types';
